/*eslint-disable*/
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { rootAPI } from '../config/api';
import { basicAuth } from '../config/auth';

export const useUser = (appId) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchUserData = useCallback(async () => {
    if (!appId) return;

    setLoading(true);
    try {
      const response = await axios.get(`${rootAPI}/api/basic/v2.0.0/auth/user/details/${appId}`, {
        headers: {
          Authorization: `Basic ${basicAuth}`,
        },
      });
      const userData = response.data?.data || response.data?.user || response.data;
      setUser(userData);
    } catch (error) {
      console.error('Failed to fetch app data:', error);
    } finally {
      setLoading(false);
    }
  }, [appId]);

  useEffect(() => {
    fetchUserData();
  }, [appId, fetchUserData]);

  return { user, userLoading: loading, refetch: fetchUserData };
};
